module.exports = __webpack_public_path__ + "static/media/koken_in_de_camper.8eaf5de1.jpg";